export default {"src":"/_next/static/media/error.0c2cdc43.gif","height":500,"width":500,"blurWidth":0,"blurHeight":0};